(() => {
  ['theme:cart:change', 'theme:cart:reload'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      const productOffersSection = document.querySelector(
        '.section-cart-product-offers'
      );
      if (!productOffersSection) return;

      const sectionId = productOffersSection.id.replace('shopify-section-', '');
      window
        .fetch(`${window.theme.routes.root_url}?section_id=${sectionId}`)
        .then(response => {
          if (!response.ok) throw new Error(response.statusText);
          return response.text();
        })
        .then(data => {
          const element = document.createElement('div');
          element.innerHTML = data;
          productOffersSection.innerHTML = element.querySelector(
            '.section-cart-product-offers'
          ).innerHTML;
        });
    });
  });
})();

(() => {
  const targetElement = document.querySelector(
    '.template-product product-form'
  );

  if (!targetElement) return;

  function handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = window.innerHeight;

    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
    const isNearBottom = distanceFromBottom <= 200;

    if (isNearBottom) {
      targetElement.classList.add('mobile--hide');
    } else {
      targetElement.classList.remove('mobile--hide');
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();
})();

(() => {
  function initCrossSellCarousel(root = document) {
    root.querySelectorAll('[data-cart-cross-sell]').forEach(block => {
      if (block.dataset.crossSellReady === 'true') return;
      block.dataset.crossSellReady = 'true';

      const track = block.querySelector('[data-cross-sell-track]');
      const prev = block.querySelector('[data-cross-sell-prev]');
      const next = block.querySelector('[data-cross-sell-next]');
      if (!track) return;

      const getStep = () => {
        const slide = track.querySelector(
          '.cart-cross-sell__slide:not([hidden])'
        );
        if (!slide) return track.clientWidth * 0.8;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide.getBoundingClientRect().width + gap;
      };

      const updateArrows = () => {
        if (!prev || !next) return;
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      next?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  function refreshCrossSell() {
    const section = document.querySelector(
      '[data-section-type="cart-drawer"]'
    );
    const wrapper = document.querySelector('[data-cart-cross-sell-wrapper]');
    if (!section || !wrapper) return;

    const sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    window
      .fetch(`${window.theme.routes.root_url}?section_id=${sectionId}`)
      .then(response => {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then(html => {
        const doc = document.createElement('div');
        doc.innerHTML = html;
        const fresh = doc.querySelector('[data-cart-cross-sell-wrapper]');
        if (!fresh) {
          wrapper.innerHTML = '';
          return;
        }
        wrapper.innerHTML = fresh.innerHTML;
        if (window.Alpine?.initTree) {
          window.Alpine.initTree(wrapper);
        }
        initCrossSellCarousel(wrapper);
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCrossSellCarousel();
  });
  initCrossSellCarousel();

  ['theme:cart:change', 'theme:cart:reload'].forEach(eventName => {
    document.addEventListener(eventName, () => {
      window.setTimeout(refreshCrossSell, 50);
    });
  });
})();
